/* eslint-disable max-len */
import React, { useCallback, useContext, useEffect, useState } from 'react'
import GlobalContext from '../../../components/Context/GloablContext'
import Table from './Components/Table';
import ChangeOngoingFY from './Components/ChangeOngoingFY';
import { useDispatch, useSelector } from 'react-redux';
import { GetBranchId } from '../../../CommonMethods/GetBranchId';
import { FinancialYearResult } from './FinancialYearSlice';
import ItemShimmer from '../../../components/Shimmer/itemShimmer';
import Pagination from '../../../components/Pagination';
import { useSearchParams } from 'react-router-dom';
import { CognitoData } from '../../../CommonMethods/CognitoData';

export default function FinancialYear() {
    const {isSideNavBar, isInactiveBranch, rolesGlobal} = useContext(GlobalContext);
    const [isChangeFY, setIsChangeFY] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams({page_number: 1});
    const dispatch = useDispatch();
    const FinancialYearList = useSelector(state => state.FinancialYearSlice)
    const [isRole, setIsRole] = useState(false)

    /**
     * The handleChangeFY function toggles the value of isChangeFY.
     */
    const handleChangeFY = () => {
        setIsChangeFY(!isChangeFY);
    }

    /* The `getFinancialYearRecodes` function is a callback function that is used to fetch financial
   year records. It uses the `useCallback` hook to memoize the function and prevent unnecessary
   re-renders. */
    const getFinancialYearRecodes = useCallback (async() => {
        const branch_id = await GetBranchId()

        dispatch(FinancialYearResult(`financial-years?${searchParams.toString()}&branch_id=${branch_id}`)).then((response) => {
        })
    }, [searchParams])
    /**
     * This function handles the click event of a page number and updates the search parameters with
     * the selected page number.
     */
    const handleOnClickPageNumber = (pageNum) => {
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
    }
    /**
     * The function `getUserRole` checks the user's role based on their custom user type and membership
     * in certain groups.
     */
    const getUserRole = async() => {
        const user = await CognitoData();
        if(user.idToken.payload["custom:user_type"] === "institution-admin") {
            setIsRole(false)
        } else if(rolesGlobal?.includes("financial-years")) {
            setIsRole(false)
        } else {
            setIsRole(true)
        }
    }


   
    /* The `useEffect` hook is used to perform side effects in a functional component. In this case,
    the `useEffect` hook is used to call the `getUserRole` and `getFinancialYearRecodes` functions
    when the component mounts or when the `getFinancialYearRecodes` function changes. */
    useEffect(() => {
        getUserRole();
        getFinancialYearRecodes()
    }, [getFinancialYearRecodes])
    return (
        <>
            <div className={` w-full main-screenInst overflow-x-hidden max-h-screen min-h-screen relative`}>
                <div className={`mainDataCntnr ${!isSideNavBar ? 'normal' : 'wide'}`}>
                    <div className={`mainDataCntnrTop shadow-s13 ${isChangeFY ? 'z-10' : 'z-20'} bg-[#fff]`} style={{ position: "sticky", position: "-webkit-sticky" }}>
                        <div className="flex items-center">
                            <h5 className="pageHeader adderror">Financial Years</h5>
                        </div>
                        {!isRole && <div className='flex items-center'>
                            <label id="label-ongoing" className='text-f8 font-semibold mr-4'>Ongoing FY: {FinancialYearList?.List?.ongoing.replace('FY', '')}</label>
                            {!isInactiveBranch && <button
                                onClick={() => handleChangeFY()}
                                disabled={isRole}
                                id='status-chnage'
                                class={`prmy-btn`} >
                                Change Ongoing FY
                            </button>}
                        </div>}
                    </div>
                    <div className='mainDataCntnrListDiv scrollBlue_thick' >
                        {FinancialYearList.loading ?
                            <ItemShimmer /> :
                            <>
                                <Table
                                    getFinancialYearRecodes={getFinancialYearRecodes}
                                    isRole={isRole}
                                />

                                {(FinancialYearList?.List?.total_count > 10) && <Pagination
                                    TotalCount={FinancialYearList.List?.total_count}
                                    totalPageNumber={Math.ceil(FinancialYearList.List?.total_count / 10)}
                                    selectedPageNumber={Number(searchParams.get('page_number')) || 1}
                                    handleOnClickPageNumber={handleOnClickPageNumber}
                                />}
                            </>
                        }
                    </div>
                </div>
            </div >
            {isChangeFY &&
                <ChangeOngoingFY
                    handleSidePopupClick={handleChangeFY}
                    ongoingFY={FinancialYearList?.List?.ongoing}
                    getFinancialYearRecodes={getFinancialYearRecodes}
                    // fetchFYStatus={fetchFYStatus}
                />
            }
        </>
    )
}
